// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"06ecfa3a","883":"51015c2e"}[chunkId] + ".chunk.js";
};